import api from './api';

export interface CompanyProfile {
  company_name: string;
  company_address: string;
  company_phone: string;
  company_email: string;
  company_website: string;
  company_tax_id: string;
  company_logo: string;
  company_description: string;
}

export interface NumberingFormats {
  invoice_format: string;
  product_sku_format: string;
  customer_code_format: string;
  supplier_code_format: string;
}

export interface CurrencySettings {
  base_currency: string;
  exchange_rates: Record<string, number>;
  currency_symbol: string;
  decimal_places: number;
}

export const settingsService = {
  async getCompanyProfile(): Promise<CompanyProfile> {
    const response = await api.get('/settings/company-profile');
    return response.data.data;
  },

  async updateCompanyProfile(data: CompanyProfile): Promise<void> {
    await api.put('/settings/company-profile', data);
  },

  async getNumberingFormats(): Promise<NumberingFormats> {
    const response = await api.get('/settings/numbering-formats');
    return response.data.data;
  },

  async updateNumberingFormats(data: NumberingFormats): Promise<void> {
    await api.put('/settings/numbering-formats', data);
  },

  async getCurrencySettings(): Promise<CurrencySettings> {
    const response = await api.get('/settings/currency-settings');
    return response.data.data;
  },

  async updateCurrencySettings(data: CurrencySettings): Promise<void> {
    await api.put('/settings/currency-settings', data);
  },

  async getAllSettings() {
    const response = await api.get('/settings');
    return response.data;
  },

  async getSettingsByCategory(category: string) {
    const response = await api.get(`/settings/category/${category}`);
    return response.data;
  },

  async updateSettingsByCategory(category: string, data: any) {
    await api.put(`/settings/category/${category}`, data);
  }
};

